  <template>
  <div id="pagesContainer" v-if="job">
    <div id="desktopJobPage">
      <b-container>
        <b-row>
          <b-col lg="8" id="columnLeft">
            <TitleSection v-bind:job="job"></TitleSection>
            <DescriptionSection
              v-bind:description="description"
            ></DescriptionSection>
          </b-col>
          <b-col lg="4" id="columnRight">
            <ApplyButtonSection v-bind:job="job"></ApplyButtonSection>
            <JobTableSection v-bind:job="job"></JobTableSection>
            <ContactSection
              v-if="job.Contact"
              v-bind:job="job"
            ></ContactSection>
          </b-col>
        </b-row>
        <b-row>
          <p></p>
        </b-row>  
        <BackButton></BackButton>
      </b-container>
    </div>
    <div id="mobileJobPage">
      <TitleSection v-bind:job="job"></TitleSection>
      <ApplyButtonSection v-bind:job="job"></ApplyButtonSection>
      <JobTableSection v-bind:job="job"></JobTableSection>
      <DescriptionSection v-bind:description="description"></DescriptionSection>
      <ContactSection
        v-if="job.Contact != null"
        v-bind:job="job"
      ></ContactSection>
    </div>
  </div>
</template>

<script>
import JobTableSection from "../components/JobPage/JobTableSection";
import TitleSection from "../components/JobPage/TitleSection";
import DescriptionSection from "../components/JobPage/DescriptionSection";
import ApplyButtonSection from "../components/JobPage/ApplyButtonSection";
import ContactSection from "../components/JobPage/ContactSection";
import BackButton from "../components/JobPage/BackButton";
export default {
  name: "JobPage",
  components: {
    JobTableSection,
    TitleSection,
    DescriptionSection,
    ApplyButtonSection,
    ContactSection,
    BackButton,
  },
  data() {
    return {
      job: { Contact: { Image: "" } },
      description: null,
    };
  },
  methods: {
    GetContentIdFromUrlSegment(urlSegment) {
      let index = urlSegment.length - 1;
      let charFromUrlSegment = urlSegment[index];
      let charIsNumeric = !isNaN(charFromUrlSegment);
      let protoContentId = "";
      while (charIsNumeric) {
        protoContentId = charFromUrlSegment + protoContentId;
        index -= 1;
        charFromUrlSegment = urlSegment[index];
        charIsNumeric = !isNaN(charFromUrlSegment);
      }
      let contentId = protoContentId;
      return contentId;
    },
    insertStructuredData(job) {
      let jsonld = {
        "@context": "https://schema.org/",
        "@type": "JobPosting",
        title: job.Name,
        description: job.Description,
        identifier: {
          "@type": "PropertyValue",
          name: "Google",
          value: "1234567",
        },
        datePosted: job.PostingDate,
        validThrough: job.ClosingDate,
        employmentType: job.ContractType,
        hiringOrganization: {
          "@type": "Organization",
          name: "Callega Klantcontact Recruitment",
          sameAs: "http://www.callega.nl",
          logo: "https://callega.nl/media/1117/callega-logo-clr.svg",
        },
        jobLocation: {
          "@type": "Place",
          address: {
            "@type": "PostalAddress",
            streetAddress: job.StreetAddress,
            addressLocality: job.Place,
            addressRegion: job.Region,
            postalCode: job.PostalCode,
            addressCountry: "NL",
          },
        },
        baseSalary: {
          "@type": "MonetaryAmount",
          currency: "EUR",
          value: {
            "@type": "QuantitativeValue",
            minValue: job.MinSalary,
            maxValue: job.MaxSalary,
            unitText: "HOUR",
          },
        },
      };

      let scriptTag = document.createElement("script");
      scriptTag.setAttribute("type", "application/ld+json");
      scriptTag.textContent = JSON.stringify(jsonld);
      document.head.appendChild(scriptTag);
    },
  },
  created() {
    var pathName = "";
    if(window.location.pathname.endsWith('/')) 
    {
      pathName = window.location.pathname.slice(0, -1);
    } else {
      pathName = window.location.pathname;
    }
    let contentId = this.GetContentIdFromUrlSegment(pathName);
    var url = "/umbraco/api/jobs/GetJobModuleDataSingleJob" +"?contentId=" + contentId
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        // set the title of the page.
        // document.title = data.Jobs[0].Name;
        this.job = data.Jobs[0];

        this.$store.commit("mutateMiscData", data.MiscData);
        // this.$store.commit(
        //   "mutateJobouselImagesSingleJob",
        //   data.Jobs[0].Images
        // );
        this.description = data.Jobs[0].Description;

        this.insertStructuredData(this.job);
      });
  },
};
</script>

<style>
.white {
  background-color: white;
}
</style>

<style scoped>
/* shared */

#desktopJobPage {
  display: none;
}
#mobileJobPage {
  display: none;
}

#JobTableSection {
  padding-top: 40px;
  margin-bottom: auto, 0;
}

/* > 992px*/
@media screen and (min-width: 992px) {
  .desktopTitle {
    background: #ffffff;
  }

  #columnLeft {
    padding-right: 10px;
  }

  #columnRight {
    padding-left: 0px;
  }

  #desktopJobPage {
    display: block;
  }
}

/* =< 991 */
@media screen and (max-width: 991px) {
  #mobileJobPage {
    display: block;
  }
}
</style>